import React from 'react';
import cn from 'classnames';

import SendMessageForm from 'widget/components/SendMessageForm';
import ConsentsBlock from 'widget/components/SubmissionForm/SubmissionFormBody/ConsentsBlock';
import type { AttachmentsStore } from 'widget/stores/AttachmentsStore';
import { LayoutVersion } from 'widget/types/common';
import type { SendAttachment } from 'widget/types/messages';

import styles from './WidgetFooter.module.scss';

export type WidgetFooterProps = {
  className?: string;
  onSendMessage?: (text: string, attachments?: SendAttachment[]) => void;
  onBeforeSend?: () => void;
  canSendWithoutMessage?: boolean;
  layout?: LayoutVersion;
  submissionFormDisablesSending?: boolean;
  showConsents?: boolean;
  attachmentsStore: AttachmentsStore;
};

const WidgetFooter: React.FC<WidgetFooterProps> = ({
  className,
  onSendMessage,
  onBeforeSend,
  canSendWithoutMessage,
  layout,
  submissionFormDisablesSending,
  showConsents = false,
  attachmentsStore
}) => {
  return (
    <div className={cn(styles['footer'], className)}>
      {showConsents && (
        <div className={styles['footer__consents']}>
          <ConsentsBlock />
        </div>
      )}
      <SendMessageForm
        layout={layout}
        onSendMessage={onSendMessage}
        submissionFormDisablesSending={submissionFormDisablesSending}
        onBeforeSend={onBeforeSend}
        canSendWithoutMessage={canSendWithoutMessage}
        attachmentsStore={attachmentsStore}
      />
    </div>
  );
};

export default React.memo(WidgetFooter);
